Customer.Ticket ||= {}

class Customer.Ticket.MassiveCloseView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/header/massive_close"]

  initialize: (@options = {}) ->
    @model = @options.model
    @selectedOption = {}

  render: ->
    @$el.html(@template(model: @model))
    @$el.find('#massive-close').chosen(width: '75px')
    @$el.find('#massive-close').on('change', (event) => @onMassiveAction(event))
    @

  onMassiveAction: (event) ->
    @_keepCustomerSessionAlive()
    selectedOption = $(event.currentTarget).find(':selected')
    if selectedOption.data('action') == 'close'
      @selectedOption = {status: 'Closed'}
    else
      @selectedOption = {status: 'Assigned'}
    @trigger('statusChanged', @selectedOption.status)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
